function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1869 24H6.81306C5.81058 24 5 23.1953 5 22.2001V3.79992C5 2.8047 5.81058 2 6.81306 2H18.1869C19.1894 2 20 2.8047 20 3.79992V22.2001C20 23.1953 19.1866 24 18.1869 24Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5987 11.4261H11.4019C9.65181 11.4261 8.23401 12.8337 8.23401 14.571V15.9956H16.7666V14.5682C16.7666 12.8337 15.3488 11.4261 13.5987 11.4261Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4851 9.30765C13.5124 9.30765 14.3451 8.47506 14.3451 7.44801C14.3451 6.42097 13.5124 5.58838 12.4851 5.58838C11.4579 5.58838 10.6251 6.42097 10.6251 7.44801C10.6251 8.47506 11.4579 9.30765 12.4851 9.30765Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4623 21.512C12.9593 21.512 13.3623 21.1091 13.3623 20.612C13.3623 20.115 12.9593 19.712 12.4623 19.712C11.9652 19.712 11.5623 20.115 11.5623 20.612C11.5623 21.1091 11.9652 21.512 12.4623 21.512Z",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAppUser = function SvgAppUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appUser.d6704d32.svg";
export { ForwardRef as ReactComponent };